<template>
  <div v-if="asyncDataStatus_ready" class="col-full push-top">
    <v-row justify="space-between">
      <h2 style="margin-left: 1rem;">
        Uredite inventar:
      </h2>
      <v-btn
        color="#0F998E"
        class="white--text"
        style="margin-right: 1rem;"
        @click="printInventoryForm"
      >
      Tiskaj
      <v-icon right dark>mdi-printer</v-icon>
      </v-btn>
    </v-row>

    <v-col>
      <CurrentStockSearchForm
        ref="currentinventoryform"
        :inventory="true"
        :inventoryData="localInventory"
        :unsaved="unsavedChanges"
        :dateDisabled="newEntry"
        @change="changedate($event); unsavedChanges = true"
        @submit="save"
        @print="print"
      />
    </v-col>

    <v-row>
      <v-col>
        <v-checkbox
          hide-details
          color="#0F998E"
          v-model="is_reset"
          label="Upoštevaj kot začetno stanje"
        ></v-checkbox>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-simple-table
          fixed-header
        >
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Artikel
                </th>
                <th class="text-left">
                  Skupina
                </th>
                <th class="text-left">
                  ME
                </th>
                <th class="text-left">
                  Vnos
                </th>
                <th class="text-left">
                  Rač. zaloga
                </th>
                <th class="text-left">
                  Razlika
                </th>
                <th class="text-left">
                  PNC
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody v-if="loaded && indexedStock.length > 0">
              <InventoryFormArticleRow
                v-for="(article, index) in indexedStock"
                :ref="`inventoryformarticlerow-${index}`"
                :key="index"
                :article="article"
                :newKez="index"
                :isNewArticle="newEntry"
                @updateBlur="updateArtileInLocalArrayOnBlue(index, $event)"
                @setCurrent="setCurrent"
                @delete="deleteArticle(index)"
                @gotonext="gotonext(index)"
                @update="updateArticleRowInLocalArray(index, $event)"
              />
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="7">
                  <AppSpinner />
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-row>
      <v-btn
        color="#0F998E"
        class="white--text ml-3"
        :disabled="false"
        @click="undoChanges"
      >
        Prekliči
      </v-btn>
      <v-btn
        color="#0F998E"
        class="white--text ml-3"
        @click="doSaveWriteoffFormArticles"
      >
        Shrani
      </v-btn>
    </v-row>
    <v-row>
      <v-col class="mt-12"></v-col>
    </v-row>
    <div ref="bottomOfThePage" style="height: 50px;"></div>
    <ConfirmDialog
      ref="confirmdialogunsaved"
      title="Opozorilo"
      text="Ali želiš izhod brez shranjevanja podatkov?"
      okBtnText="Razumem"
      :normal="false"
      v-model="showWarningModal"
    />
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'
import CurrentStockSearchForm from '@/components/CurrentStockSearchForm'
import InventoryFormArticleRow from '@/components/InventoryFormArticleRow'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import ConfirmDialog from '@/components/ConfirmDialog'

export default {
  components: {
    CurrentStockSearchForm,
    InventoryFormArticleRow,
    ConfirmDialog
  },
  mixins: [
    asyncDataStatus
  ],
  props: {
    id: {
      required: true,
      type: Number
    },
    newEntry: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      localArticles: [],
      localCurrentStock: [],
      indexedStock: [],
      localEndDate: null,
      localInventory: null,
      unsavedChanges: false,
      showWarningModal: false,
      currentArticle: null,
      is_reset: false,
      loaded: false
    }
  },
  methods: {
    ...mapActions('inventoryForms', ['loadItem', 'saveItem']),
    ...mapActions('inventoryForms', { saveInventoryFormArticles: 'saveArticles' }),
    ...mapActions('currentStock', { loadCurrentStockData: 'loadItems', }),
    setUnsavedChanges () {
      this.unsavedChanges = true
    },
    changedate (date) {
      this.localEndDate = date
    },
    handleFocusOut () {
      this.showWarningModal = true
    },
    printInventoryForm () {
      let routeData = this.$router.resolve({ name: 'MyCompanyInventoryFormPreview', params: { id: this.id } })
      window.open(routeData.href, '_blank')
    },
    save ({ data }) {
      if (!this.unsavedChanges) return
      this.doSaveWriteoffFormArticles()
    },
    cancel () {
      this.$router.push({ name: 'MyCompanyInventoryForms' })
    },
    doSaveWriteoffFormArticles () {
      this.saveInventoryFormArticles({
        inventoryId: this.id,
        item: {
          articles: this.localArticles.filter(art => art.price).map(art => ({ article: art.article, price: art.price, quantity: art.quantity }))
        }
      })
        .then(response => {
          this.unsavedChanges = false
          const editedFormData = this.$refs.currentinventoryform.returnInventoryForm()
          this.saveItem({ id: this.id, date: editedFormData.endDate, comment: editedFormData.comment, is_reset: this.is_reset })
          this.$router.replace({ name: 'MyCompanyInventoryForms' })
        })
    },
    setCurrent (toSet) {
      this.currentArticle = toSet
    },
    updateArtileInLocalArrayOnBlue (index, article) {
      index = this.localArticles.findIndex(lA => lA.article == article.article)
      this.localArticles[index] = article
      if (!article.quantity && typeof (article.quantity) !== 'number') {
        // remove article from localArticles
        this.localArticles.splice(index, 1)
      }
      this.unsavedChanges = true
    },
    updateArticleRowInLocalArray (index, article) {
      index = this.localArticles.findIndex(lA => lA.article == article.article)
      this.localArticles[index] = article
      if (!article.quantity && typeof (article.quantity) !== 'number') {
        // remove article from localArticles
        this.localArticles.splice(index, 1)
      }
      const indexSeq = this.currentArticle + 1
      this.unsavedChanges = true
      const geenrated = `inventoryformarticlerow-${indexSeq}`

      this.$refs[geenrated][0].$refs.new_quantity.focus()
    },
    gotonext() {
      const indexSeq = this.currentArticle + 1
      const geenrated = `inventoryformarticlerow-${indexSeq}`
      this.$refs[geenrated][0].$refs.new_quantity.focus()
    },
    deleteArticle (index) {
      this.localArticles.splice(index, 1)
      const newArray = this.localArticles
      this.localArticles = []
      this.$nextTick(() => {
        this.localArticles = newArray
      })
      this.unsavedChanges = true
    },
    undoChanges () {
      this.$router.push({ name: 'MyCompanyInventoryForms' })
    },
    async initializeAndSetData () {
      let response = await this.loadItem(this.id)
      this.localInventory = response
      this.localArticles = response.articles
      this.is_reset = response.is_reset
      let currentStockData = await this.loadCurrentStockData({ filters: { dateTo: moment(this.localInventory.date).format('YYYY-MM-DD') } })
      this.localCurrentStock = currentStockData["undefined"].articles
      this.localArticles = this.localArticles.filter(lA => this.localCurrentStock.find(stArt => stArt.article === lA.article))
      return
    },
    async localIndexedStock () {
      let sort = 0
      let slCollator = new Intl.Collator('sl', { sensitivity: 'base' })
      this.localCurrentStock.forEach(stockItem => {
        if (!this.localArticles.some(localArticl =>
          localArticl.article === stockItem.article
        ))
          {
            this.localArticles.push({ ...stockItem, addedAfter: true })
          }
      })
      return this.localArticles.map((article, i) => {
        const articleExists = this.localCurrentStock.find(stArt => stArt.article === article.article)
        const item = {
          ...article,
          problematicArticle: !articleExists,
          average_purchase_price: articleExists ? articleExists.average_purchase_price : 'Ni podatka',
          category: articleExists ? articleExists.category : 0,
          category_name: articleExists ? articleExists.category_name : 'Ni podatka',
          quantity: articleExists ? articleExists.quantity : 0,
          new_quantity: article.quantity,
        }
        return item
        })
        .sort((a, b) => {
          // Compare by category_name first
          const categoryComparison = slCollator.compare(a.category_name, b.category_name);
          if (categoryComparison === 0) {
            // If category names are the same, sort by article_name using the same Slovenian collator
            return slCollator.compare(a.article_name, b.article_name);
          }
          // Otherwise, sort by category_name
          return categoryComparison;
        })
        .map(article => {
          const item = {
            ...article,
            sort: sort
          }
          sort++
          return item
        })
    }
  },
  async created () {
    this.loaded = false
    await this.initializeAndSetData()
    this.asyncDataStatus_fetched()
    this.loaded = true
    this.indexedStock = await this.localIndexedStock()
  },
  watch: {
    localEndDate (val, prevval) {
      if (!val) return
      this.loaded = false
      Promise.all([this.loadItem(this.id),
        this.loadCurrentStockData({ filters: { dateTo: moment(val).format('YYYY-MM-DD') } })])
        .then(res => {
          this.localInventory = res[0]
          this.localArticles = res[0].articles // articles on this inventory ID
          this.localCurrentStock = res[1]["undefined"].articles // current stock's articles by current date set
          this.loaded = true
        })
    }
  },
  async beforeRouteLeave (to, from, next) {
    if (to.name === 'MyCompanyInventoryForms') {
      next()
    } else {
      this.showWarningModal = true
      next(await this.$refs.confirmdialogunsaved.pop())
    }
  }
}
</script>
